@import './ui-cms-grid';
/* stylelint-disable declaration-no-important */
ui-cms-grid {
  > div.mglEditor.mglPlaceholder > div.mgnlEditorBar.component {
    grid-column: span 12;
  }

  > div.mgnlEditorBar.area.end {
    margin-top: calc(var(--grid-row-gap, 60) * -1px) !important;
    grid-column: span 12;
  }
}
